import * as React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCheck }  from '@fortawesome/fontawesome-free-solid';
import './SectionIndicator.css';
import * as cx from 'classnames';

interface Props {
    sectionNumber: number;
    completed: boolean;
}

function CheckIcon () {
    return (
        <FontAwesomeIcon
            icon={faCheck}
            color="#white"
        />
    );
}

function getClasses(completed: boolean) {
    return cx('section-indicator', {
        'completed': completed
    });
}

class SectionIndicator extends React.Component<Props> {
    render() {
        const { sectionNumber, completed } = this.props;

        return (
            <div className={getClasses(completed)}>
                {!completed &&
                    <span>{sectionNumber}</span>
                }
                { completed &&
                    <CheckIcon />
                }
            </div>
        );
    }
}

export default SectionIndicator;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/nav/topNav/SectionIndicator.tsx